export const EmptyUserFilter = { 
    firstName: "", 
    lastName: "",
    auditName: "",
    email : "",  
    organisation: [],
    active: []
};